module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [(_vm.speciesData.name === '') ? _c('div', {
    staticClass: "cards"
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._l((_vm.cards), function(card, index) {
    return _c('div', {
      key: index,
      staticClass: "species-card"
    }, [_c('Card', {
      attrs: {
        "isReversed": index % 2 === 1,
        "pictureUrl": card.pictureUrl,
        "title": card.title,
        "description": card.description
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "back-top"
  }, [_c('div', {
    staticClass: "clickable",
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  }), _vm._v(" "), _c('p', [_vm._v("Back to top")])])])], 2) : _vm._e(), _vm._v(" "), (_vm.speciesData.name !== '') ? _c('div', {
    staticClass: "hero-species"
  }, [_c('HeroSpecies'), _vm._v(" "), _c('ActionForm', {
    attrs: {
      "datalayerName": _vm.datalayerName,
      "programName": _vm.programName,
      "messageId": _vm.messageId
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.speciesData.name !== '') ? _c('div', {
    staticClass: "other"
  }, [_c('Other')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "partners"
  }, [_c('Partners')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("My Backyard")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        Learn about the wildlife that call your backyard home\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5e6641e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/threatened-species/ThreatenedSpecies.vue
// module id = 789
// module chunks = 0